import axios from 'axios';
import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { DateRange } from 'react-date-range';
import * as rdrLocales from 'react-date-range/src/locale';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { connect } from 'react-redux';
import Select from 'react-select';
import Switch from 'react-switch';
import { bindActionCreators } from 'redux';
import WidgetSearchName from '../../components/Header/widget-searchName';
import Loading from '../../components/Loading';
//import WidgetsReaction from '../../components/Widgets/widget-reaction';
import auth from '../../libCustom/auth';
import * as ClientsActions from '../../views/Clients/redux/ClientsActions';
import * as QuotationsActions from '../../views/Quotations/redux/QuotationsActions';
import quotationIcon from '../../assets/img/beach.png';
import girlIcon from '../../assets/img/girl.png';
import manIcon from '../../assets/img/man.png';

const options = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];

let people = [];
for (let i = 0; i <= 100; i++) {
  people.push({ value: i, label: i });
}

const saludation = [
  { value: '', label: '-- Seleccionar' },
  { value: 'Sr.', label: 'Sr.' },
  { value: 'Sra.', label: 'Sra.' },
  { value: 'Srta.', label: 'Srta.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Lic.', label: 'Lic.' },
  { value: 'Arq.', label: 'Arq.' },
  { value: 'Ing.', label: 'Ing.' },
  { value: 'Mtro.', label: 'Mtro.' },
  { value: 'Joven', label: 'Joven' },
];

const fromArray = [
  { value: '', label: '-- Seleccionar' },
  { value: 'Redes sociales', label: 'Redes sociales' },
  { value: 'Recomendación', label: 'Recomendación' },
  { value: 'Publicidad', label: 'Publicidad' },
  { value: 'others', label: 'Otros' },
];
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      idQuotation: '',
      clientData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        notes: '',
        findClient: false,
        saludation: '',
        reaction: '',
        from: '',
        otherContact: '',
      },
      formData: {
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        validDate: '',
        destination: '',
        interest: '',
        adults: '',
        juniors: '',
        kids: '',
        notesQuotation: '',
        assignedTo:
          auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
        group: false,
        down: false,
        status: 'leats',
      },
      dates: {
        departureDate: moment(),
        returnDate: moment(),
        openDate: false,
        duration: '',
      },
      showModal: false,
      optionsSelect: {
        users: [],
        clients: [],
      },
      openDateDisabled: false,
      days: 0,
      openSuccess: false,
    };
  }

  componentWillMount() {
    if (!auth.verifyLogin()) return false;
    const franchiseId = auth.getCurrentUser().franchiseId;
    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
        isDeleted: { neq: true },
      },
    };

    this.getOptionsSelect(
      'users',
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(params),
      (option) => {
        return {
          label: option.firstName + ' ' + option.lastName,
          value: option.id,
        };
      }
    );
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    let response = await axios.get(url);
    let options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });

    options.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      return labelA.localeCompare(labelB);
    });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
      clients: response.data,
    });
  };

  handleChange(id, checked) {
    if (checked === true) {
      this.setState({
        dates: {
          ...this.state.dates,
          openDate: true,
          returnDate: moment(),
          departureDate: moment(),
        },
        openDateDisabled: true,
      });
    } else {
      this.setState({
        dates: {
          ...this.state.dates,
          openDate: false,
          returnDate: moment(),
          departureDate: moment(),
        },
        openDateDisabled: false,
      });
    }
    this.onChange(id, checked);
  }

  calculate = () => {
    const startDate = moment(this.props.Quotations.dates.departureDate);
    const timeEnd = moment(this.props.Quotations.dates.returnDate);
    const diff = timeEnd.diff(startDate);
    const diffDuration = moment.duration(diff);
    const nights = diffDuration.days() - 1;
    this.setState({
      days: nights,
    });
  };

  save = async () => {
    let _this = this;
    return new Promise(async function (resolve, reject) {
      if (_this.state.clientData.findClient === false) {
        let newPostClient = {
          ..._this.state.clientData,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };
        let createClient = await axios.post(
          process.env.REACT_APP_URL_API + '/api/clients',
          newPostClient
        );

        let newQuotationPost = {
          clientId: createClient.data.id,
          generalQuotation: _this.state.formData,
          dates: _this.state.dates,
          lodgings: [],
          flights: [],
          otherServices: [],
          packages: [],
          franchiseId: '',
          franchiseNumber: auth.getCurrentUser().franchise.privateId,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };

        newQuotationPost.status = 'leats';
        newQuotationPost.ordenGenerated = false;

        axios
          .post(
            process.env.REACT_APP_URL_API + '/api/quotations',
            newQuotationPost
          )
          .then(function (res) {
            _this.setState({ idQuotation: res.data.id });
            resolve(res);
          });
      } else {
        await axios.patch(
          process.env.REACT_APP_URL_API +
          '/api/clients/' +
          _this.state.clientData.id,
          _this.state.clientData
        );

        let newQuotationPost = {
          clientId: _this.state.clientData.id,
          generalQuotation: _this.state.formData,
          dates: _this.state.dates,
          lodgings: [],
          flights: [],
          otherServices: [],
          packages: [],
          franchiseId: '',
          franchiseNumber: auth.getCurrentUser().franchise.privateId,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };

        newQuotationPost.status = 'leats';
        newQuotationPost.ordenGenerated = false;

        let saveQuotation = await axios.post(
          process.env.REACT_APP_URL_API + '/api/quotations',
          newQuotationPost
        );

        _this.setState({ idQuotation: saveQuotation.data.id });
        resolve(saveQuotation);
      }
    });
  };

  handledCompleteForm = (event) => {
    event.preventDefault();
    let _this = this;
    this.setState({ loading: true });
    //DONE Paty - Revisar que guarde la información correctamente para el cliente, por que no lo actualiza.
    _this.save().then(function (res) {
      _this.handleRedirect(res);
    });
  };

  handleRedirect = function (res) {
    if (res.status === 200) {
      this.setState({ loading: false, openSuccess: true });
      this.props.ClientsActions.find({
        $limit: 30,
        $sort: {
          createdAt: -1,
        },
        deleted: { $exists: false },
        franchiseId: auth.getCurrentUser().franchiseId,
        $populate: {
          path: 'assignedTo',
          select: '_id email firstName lastName franchiseId phone',
        },
      });

      //alert('Enviado a prospectos satisfactoriamente');

      this.setState({
        showModal: false,
        clientData: {
          id: '',
          firstName: '',
          lastName: ' ',
          phone: '',
          email: '',
          notes: '',
          findClient: false,
          reaction: '',
          from: '',
        },
        formData: {
          userId:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
          validDate: '',
          destination: '',
          interest: '',
          adults: '',
          juniors: '',
          kids: '',
          notesQuotation: '',
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
          executive:
            auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
          group: false,
          down: false,
          status: 'leats',
        },
        dates: {
          departureDate: moment(),
          returnDate: moment(),
          openDate: false,
          duration: '',
        },
        openDateDisabled: false,
      });
    } else {
      //console.log('Error', res);
    }
    if (
      this.state.idQuotation !== '' ||
      this.state.idQuotation !== null ||
      this.state.idQuotation !== undefined
    ) {
      this.props.history.push('/admin/quotations/' + this.state.idQuotation);
    }
  };

  onChangeDates = (path, value) => {
    var newFormData = immutable.set(this.state.dates, path, value);

    this.setState({
      dates: newFormData,
    });
  };

  onChangeClient = (path, value) => {
    var newFormData = immutable.set(this.state.clientData, path, value);

    this.setState({
      clientData: newFormData,
    });
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  findClient = (value) => {
    axios
      .get(process.env.REACT_APP_URL_API + '/api/clients/' + value)
      .then((res) => {
        this.setState({
          clientData: {
            id: res.data.id,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            phone: res.data.phone,
            email: res.data.email,
            notes: res.data.notes,
            saludation: res.data.saludation,
            reaction: res.data.reaction,
            from: res.data.from,
            findClient: true,
            otherContact: res.data.otherContact,
          },
        });
      });
  };

  copyTheName = (name) => {
    this.setState({
      clientData: {
        ...this.state.clientData,
        firstName: name,
      },
    });
  };

  handleRangeChange = (payload) => {
    let endDate = moment(payload.selection.endDate);
    let startDate = moment(payload.selection.startDate);

    const diff = endDate.diff(startDate, 'days');

    this.setState({
      days: diff,
      dates: {
        ...this.state.dates,
        returnDate: endDate,
        departureDate: startDate,
      },
    });
  };

  render() {
    const { optionsSelect, openSuccess, loading } = this.state;
    const styles = {
      label: {
        fontWeight: '400',
      },
      importantLabel: {
        fontWeight: '400',
        color: '#fb4040',
      },
      title: {
        color: '#497dc1',
        fontSize: '18px',
      },
      subTitle: {
        fontWeight: '300',
        fontSize: '22px',
        lineHeight: '30px',
      },
    };

    return (
      <div className="main-content">
        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Se ha enviado a prospectos correctamente!"
            confirmBtnBsStyle="info"
            onConfirm={() => {
              this.setState({ openSuccess: false });
            }}
          />
        )}
        {loading ? (
          <Loading />
        ) : (
          <form onSubmit={this.handledCompleteForm}>
            <Grid fluid>
              <Row>
                <Col md={6}>
                  <div className={'pull-left'}>
                    <h4>Agregar Prospecto</h4>
                  </div>
                </Col>
                <Col md={6}>
                  <div className={'pull-right'} style={{ marginTop: 20 }}>
                    <Button bsStyle="primary" fill type="submit">
                      Guardar
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={4} md={12} sm={12}>
                  <Card
                    ctFullWidth
                    content={
                      <Grid fluid>
                        <Row>
                          <Col md={12}>
                            <span style={styles.subTitle}>
                              Información del Cliente
                            </span>

                            <img
                              src={girlIcon}
                              style={{
                                width: '25px',
                                marginLeft: '7px',
                                marginBottom: '5px',
                              }}
                              alt="girlIcon"
                            />
                            <img
                              src={manIcon}
                              style={{
                                width: '25px',
                                marginLeft: '3px',
                                marginBottom: '5px',
                              }}
                              alt="manIcon"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="form-group">
                              <label
                                htmlFor="client"
                                style={styles.importantLabel}
                              >
                                BÚSQUEDA DE CLIENTE
                              </label>
                              <WidgetSearchName
                                schema={{
                                  creatable: false,
                                  title:
                                    'Buscar cliente por nombre, telefono o correo',
                                  api:
                                    process.env.REACT_APP_URL_API +
                                    '/api/clients',
                                }}
                                value={''}
                                required={false}
                                onChange={(value) => this.findClient(value)}
                                onCreate={(value) => this.copyTheName(value)}
                              />
                              <br />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="firstName" style={styles.label}>
                                Saludo
                              </label>
                              <Select
                                required
                                placeholder="-- Seleccionar"
                                name="userId"
                                value={this.state.clientData.saludation}
                                options={saludation}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChangeClient(
                                      'saludation',
                                      event.value
                                    );
                                  } else {
                                    this.onChangeClient('saludation', '');
                                  }
                                }}
                              />
                              <input
                                style={{
                                  height: 1,
                                  padding: 0,
                                  margin: 0,
                                  border: 0,
                                  color: 'white',
                                }}
                                required
                                type="text"
                                id="userIdHidden"
                                value={this.state.clientData.saludation}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="from" style={styles.label}>
                                Medio de Contacto
                              </label>
                              <Select
                                required
                                placeholder="-- Seleccionar"
                                name="from"
                                value={this.state.clientData.from}
                                options={fromArray}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChangeClient('from', event.value);
                                  } else {
                                    this.onChangeClient('from', '');
                                  }
                                }}
                              />
                              <input
                                style={{
                                  height: 1,
                                  padding: 0,
                                  margin: 0,
                                  border: 0,
                                  color: 'white',
                                }}
                                type="text"
                                id="userIdHidden"
                                value={this.state.clientData.from}
                              />
                            </div>
                          </Col>

                          {this.state.clientData.from === 'others' && (
                            <Col lg={12} md={12} sm={12}>
                              <div className="form-group">
                                <label
                                  htmlFor="otherContact"
                                  style={styles.label}
                                >
                                  Especificar otro medio
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="otherContact"
                                  value={this.state.clientData.otherContact}
                                  onChange={(event) =>
                                    this.onChangeClient(
                                      'otherContact',
                                      event.target.value
                                    )
                                  }
                                />
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="firstName" style={styles.label}>
                                Nombre
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                id="firstName"
                                value={this.state.clientData.firstName}
                                onChange={(event) =>
                                  this.onChangeClient(
                                    'firstName',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="lastName" style={styles.label}>
                                Apellidos
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                id="lastName"
                                value={this.state.clientData.lastName}
                                onChange={(event) =>
                                  this.onChangeClient(
                                    'lastName',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="phone" style={styles.label}>
                                Teléfono celular
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                id="phone"
                                value={this.state.clientData.phone}
                                onChange={(event) =>
                                  this.onChangeClient(
                                    'phone',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="email" style={styles.label}>
                                Email
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="email"
                                value={this.state.clientData.email}
                                onChange={(event) =>
                                  this.onChangeClient(
                                    'email',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <div className="form-group">
                              <label htmlFor="notes" style={styles.label}>
                                Notas del cliente
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                id="notes"
                                value={this.state.clientData.notes}
                                onChange={(event) =>
                                  this.onChangeClient(
                                    'notes',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </Grid>
                    }
                  />
                </Col>

                <Col lg={8} md={12} sm={12}>
                  <Card
                    ctFullWidth
                    content={
                      <Grid fluid>
                        <Row>
                          <Col md={12}>
                            <span style={styles.subTitle}>
                              Información de la Cotización
                            </span>

                            <img
                              src={quotationIcon}
                              style={{
                                width: '25px',
                                marginLeft: '7px',
                                marginBottom: '5px',
                              }}
                              alt="quotationIcon"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="client" style={styles.label}>
                                Asignado a
                              </label>
                              <Select
                                placeholder="-- Seleccionar"
                                name="userId"
                                value={this.state.formData.userId}
                                options={optionsSelect.users}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChange('userId', event.value);
                                  } else {
                                    this.onChange('userId', '');
                                  }
                                }}
                              />
                              <input
                                style={{
                                  height: 1,
                                  padding: 0,
                                  margin: 0,
                                  border: 0,
                                  color: 'white',
                                }}
                                required
                                type="text"
                                id="userIdHidden"
                                value={this.state.formData.userId}
                                onChange={() => console.log()}
                              />
                            </div>
                          </Col>
                          <Col lg={6} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="validDate" style={styles.label}>
                                Válido hasta
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="validDate"
                                value={this.state.formData.validDate}
                                onChange={(event) =>
                                  this.onChange('validDate', event.target.value)
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="reference" style={styles.label}>
                                Destino
                              </label>
                              <input
                                type="text"
                                required
                                className="form-control"
                                id="destination"
                                value={this.state.formData.destination}
                                onChange={(event) =>
                                  this.onChange(
                                    'destination',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                          <Col lg={6} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="reference" style={styles.label}>
                                Interés
                              </label>
                              <Select
                                placeholder="-- Seleccionar"
                                name="interest"
                                value={this.state.formData.interest}
                                options={options}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChange('interest', event.value);
                                  } else {
                                    this.onChange('interest', '');
                                  }
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="reference">Adultos</label>
                              <Select
                                placeholder="-- Elegir"
                                name="adults"
                                value={this.state.formData.adults}
                                options={people}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChange('adults', event.value);
                                  } else {
                                    this.onChange('adults', '');
                                  }
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={4} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="reference">Juniors</label>
                              <Select
                                placeholder="-- Elegir"
                                name="juniors"
                                value={this.state.formData.juniors}
                                options={people}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChange('juniors', event.value);
                                  } else {
                                    this.onChange('juniors', '');
                                  }
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={4} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="reference">Niños</label>
                              <Select
                                placeholder="-- Elegir"
                                name="kids"
                                value={this.state.formData.kids}
                                options={people}
                                onChange={(event) => {
                                  if (event) {
                                    this.onChange('kids', event.value);
                                  } else {
                                    this.onChange('kids', '');
                                  }
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={8}>
                            <div className="form-group">
                              <label htmlFor="reference" style={styles.label}>
                                Observaciones de la cotización
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                id="notesQuotation"
                                value={this.state.formData.notes}
                                onChange={(event) =>
                                  this.onChange('notes', event.target.value)
                                }
                              />
                            </div>
                          </Col>
                          <Col lg={2} md={12} sm={12}>
                            <div className="form-group">
                              <label htmlFor="openDate" style={styles.label}>
                                Fecha abierta
                              </label>
                            </div>
                            <div className="form-group">
                              <Switch
                                checked={this.state.dates.openDate}
                                onChange={(checked) =>
                                  this.handleChange('openDate', checked)
                                }
                              />
                            </div>
                          </Col>

                          {!this.state.openDateDisabled ? (
                            <Col lg={2} md={12} sm={12}>
                              <div className="form-group">
                                <label htmlFor="reference" style={styles.label}>
                                  Duración (noches)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="days"
                                  value={this.state.days}
                                  onChange={(event) =>
                                    this.props.dispatch(
                                      QuotationsActions.onChange(
                                        ['dates', 'duration'],
                                        event.target.value
                                      )
                                    )
                                  }
                                  disabled
                                />
                              </div>
                            </Col>
                          ) : null}
                        </Row>

                        <Row>
                          <Col lg={8}>
                            <div className="form-group">
                              <label htmlFor="trackingLine" style={styles.label}>
                                Línea de Seguimiento
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                id="trackingLine"
                                value={this.state.formData.trackingLine}
                                onChange={(event) =>
                                  this.onChange(
                                    'trackingLine',
                                    event.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            {!this.state.openDateDisabled ? (
                              isMobileOnly || isTablet ? (
                                <Grid fluid>
                                  <Row>
                                    <Col lg={12} md={12} sm={12}>
                                      <DateRange
                                        onChange={this.handleRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        months={2}
                                        locale={rdrLocales['es']}
                                        minDate={new Date()}
                                        direction={'vertical'}
                                        ranges={[
                                          {
                                            startDate:
                                              this.state.dates.departureDate,
                                            endDate:
                                              this.state.dates.returnDate,
                                            key: 'selection',
                                          },
                                        ]}
                                        className={'PreviewArea'}
                                      />
                                    </Col>
                                  </Row>
                                </Grid>
                              ) : (
                                <Grid fluid>
                                  <Row>
                                    <Col lg={12} md={12} sm={12}>
                                      <DateRange
                                        onChange={this.handleRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        months={2}
                                        locale={rdrLocales['es']}
                                        minDate={new Date()}
                                        direction={'horizontal'}
                                        ranges={[
                                          {
                                            startDate:
                                              this.state.dates.departureDate,
                                            endDate:
                                              this.state.dates.returnDate,
                                            key: 'selection',
                                          },
                                        ]}
                                        className={'PreviewArea'}
                                      />
                                    </Col>
                                  </Row>
                                </Grid>
                              )
                            ) : null}
                          </Col>
                        </Row>
                      </Grid>
                    }
                  />
                </Col>
              </Row>
            </Grid>
          </form>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Quotations: state.Quotations,
    Clients: state.Clients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ClientsActions: bindActionCreators(ClientsActions, dispatch),
    QuotationsActions: bindActionCreators(QuotationsActions, dispatch),
  };
};

const DashboardConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);

export default DashboardConnect;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx